// extracted by mini-css-extract-plugin
module.exports = {"myAccount":"MyAccount_myAccount__cUfio","label":"MyAccount_label__4aASS","currentTab":"MyAccount_currentTab__miMKW"};